import { AppBaseEntity } from ".";
import { ProductData } from "./product";

export enum DocumentType {
  ACCEPTANCE = "ACCEPTANCE",
  DISPATCH = "DISPATCH",
}

export enum DocumentStatus {
  OPEN = "OPEN",
  PENDING = "PENDING",
  CLOSED = "CLOSED",
}

export interface Warehouse extends AppBaseEntity {
  id: number;
  name: string;
  hasWarehouseLocations: boolean;
  warehouseLocations: WarehouseLocation[];
}

export interface WarehouseLocation extends AppBaseEntity {
  id: number;
  name: string;
  warehouseId: number;
}

export interface DocumentsData extends AppBaseEntity {
  externalId: string;
  type: DocumentType;
  status: DocumentStatus;
  warehouseId: number;
  customerCode: string;
  customerDisplayName: string;
  destinationCode: string;
  destinationDisplayName: string;
  carriageDescription: string;
  date: Date;
  notes: string;
  externalNotes: string;
  products: ProductData[];
  externalDocument?: string;
  externalWebDocument?: string;
  ddtNumber?: string;
  address?: string;
  city?: string;
  province?: string;
  country?: string;
  postalCode?: string;
  phoneNumber?: string;
  shipmentCost?: number;
  documentPath?: string;
  warehouse: Warehouse;
}
